<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX19soPRvnSbjKS8ReV+VBWCtd7UPM+aakRI=",
          "cpf": "U2FsdGVkX183TcHBcpx0mTfvMsSJOTqoczlTY9elyn8="
        }, {
          "num_cand": "U2FsdGVkX19TNCMDeKLbwQV5a4Iefir5icpoC1T2668=",
          "cpf": "U2FsdGVkX19/AmCksH+2rHVlwsMAaCz61T/N4TRWhbU="
        }, {
          "num_cand": "U2FsdGVkX19SM8s5mgrqyWgvo6rN/X3W20XEMo7B5fA=",
          "cpf": "U2FsdGVkX19/LvPbdfqnv4WRtjf+m25KH1FEq9oKpzI="
        }, {
          "num_cand": "U2FsdGVkX180l7B7kB8auTEwIj3CSfa4k/pkZYROduw=",
          "cpf": "U2FsdGVkX1/CH5amqe+9jF8Q9hwZ+6GJqaZdHTB5Js4="
        }, {
          "num_cand": "U2FsdGVkX1/Xx6kz2Vg7Nt6avYOw5TCi0Rjt+HsHWBk=",
          "cpf": "U2FsdGVkX1/lr/f82a/773ZXwO6yrvCUxkJrKU0louo="
        }, {
          "num_cand": "U2FsdGVkX1+L/pMoVS4RuNufNk4QH6vcHyodgtWgOHw=",
          "cpf": "U2FsdGVkX1/d9tzqib40x+NPrQlBjvRVOaQmBiyNSbY="
        }, {
          "num_cand": "U2FsdGVkX1/IexODLPE4dazfjwTpfHgLYdyYQVTElyY=",
          "cpf": "U2FsdGVkX1+lALrcRLLJgFRIS5+TPPuloRZ4hMrStzE="
        }, {
          "num_cand": "U2FsdGVkX1+jwbpl85qoNr2qWnfZEwRpoBfXl6R8MhE=",
          "cpf": "U2FsdGVkX1+Hr2gFAvtKgCKtV/7TGlYHPhm4eeKgbcE="
        }, {
          "num_cand": "U2FsdGVkX1+RlX8NfE9wLxye1M0FgFSEs5qyMoghQFE=",
          "cpf": "U2FsdGVkX19jpB6xLoLdBM5txswc2uoL+QPzx30AZE0="
        }, {
          "num_cand": "U2FsdGVkX1/oA7GBBHFtUtrxnwmkyTuvqY1//8wmgOw=",
          "cpf": "U2FsdGVkX1+cDrlY+Oiy1UJHpjGWRYVvZueOaxo/RfE="
        }, {
          "num_cand": "U2FsdGVkX1+6CPr4RoiwVJj2pGJwK0sFaZfOO/C7wNY=",
          "cpf": "U2FsdGVkX198o0T/SDbsMMgq/1RuZLdi5MM1NqJ19QM="
        }, {
          "num_cand": "U2FsdGVkX1+SeEsujqXeZbuDqLxLyxh0jBJk9rGdTPo=",
          "cpf": "U2FsdGVkX19ia6XanrBpj9dyVuihlCwvrZiMz2zMddY="
        }, {
          "num_cand": "U2FsdGVkX18cFhS7nCNsaYna2ISUHzR4EPnwtwKjEsI=",
          "cpf": "U2FsdGVkX190NwbYQKuNyYdaXnTEq+Y9dhVkajiPZE8="
        }, {
          "num_cand": "U2FsdGVkX18hJQY0OeSfcNP54wQ9+rQWxMey6mSDBwU=",
          "cpf": "U2FsdGVkX1+6eaE7Nj94fmFilE5hb6mPSxe5rQ4s6+Y="
        }, {
          "num_cand": "U2FsdGVkX18KRA0rHYPxzar8vGZrNuELdQUIr0RqpqU=",
          "cpf": "U2FsdGVkX1+2ZZpVc61VVnhNg99XW2I7tIb94ka7ZBE="
        }, {
          "num_cand": "U2FsdGVkX18gaKE7GMng4yUdnqKs0Rg9z/Da36+I1L8=",
          "cpf": "U2FsdGVkX19pD2kymOm5dKUHx1AJ5oMCIX3s/lkMq1c="
        }, {
          "num_cand": "U2FsdGVkX1/r23fQKSQOFxL/e0kHI6qvtVKtGMtfiVk=",
          "cpf": "U2FsdGVkX18umX1zRMfl6ohzIxuDs7oudj/tq4yidLc="
        }, {
          "num_cand": "U2FsdGVkX18RXHVhnK6bQYVZabV9CURG72dW1eJje+Y=",
          "cpf": "U2FsdGVkX18UZD+gIqEX7hMWrZtQeb1JQvMtUtHZbxk="
        }, {
          "num_cand": "U2FsdGVkX1+SOs26wS0u3yg5QEtBRYVzKssdT+BEZIE=",
          "cpf": "U2FsdGVkX1+0GahTAOly2BYa8Cjp5ygSJdxmOdVPhVo="
        }, {
          "num_cand": "U2FsdGVkX1+fynfyKotwdROR/Ox/s2oqgIqIvAN7uyw=",
          "cpf": "U2FsdGVkX1+hTmOKxwK13UwZ6WMZHll5yFyhGsSnuPY="
        }, {
          "num_cand": "U2FsdGVkX1+aIUxN1HpsPdPJ/53OsEH8mr/INjQhYmM=",
          "cpf": "U2FsdGVkX18rPcTJw/r8bq0VftXx7Lb46BiQ/7NSPbI="
        }, {
          "num_cand": "U2FsdGVkX1+Isn8DH7XFnyuY2EMMGzF46JDciIG0IJk=",
          "cpf": "U2FsdGVkX1+ZLN2uLR/HldpWrIAPmqvetmU3XbVMc18="
        }, {
          "num_cand": "U2FsdGVkX1/xnX29C0uwyoQIxf1bnbjo7SuV9sA2t+s=",
          "cpf": "U2FsdGVkX1+nAnGNsidiv4WWmZ/GhJwUqLXpskwXc+Q="
        }, {
          "num_cand": "U2FsdGVkX18jG2ji5njBZGelL6W32jyEEqH2UkIpAqQ=",
          "cpf": "U2FsdGVkX18XZwYNK6wBNdtbhH/K7IboaK8mKPcnSkU="
        }, {
          "num_cand": "U2FsdGVkX1+Sm376S2/xbGraZGh+95R1shO/65/nVLo=",
          "cpf": "U2FsdGVkX1+rjr/YFuz9bjtaXxuzutCIvlG4tFKQ95Y="
        }, {
          "num_cand": "U2FsdGVkX1/8OJimHIGUyacMM5Fea6LWMkbn1z/c7k8=",
          "cpf": "U2FsdGVkX19X/MCQj0KIiaE0y2kcnCe2004BSmV5RBk="
        }, {
          "num_cand": "U2FsdGVkX19q6Ixb6vTzAnsfx1s+A8KoEVUdV+hFT3c=",
          "cpf": "U2FsdGVkX18oJQ9kd2qu/Pyb3w9r7D/wGSmFLtiLXVE="
        }, {
          "num_cand": "U2FsdGVkX1+l79YMvVw1W17H2B9JnrznX3bFZvxLInI=",
          "cpf": "U2FsdGVkX1/dF59zShll8XQR7oZwjjERXDp/0cMlO2c="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2209/2209_re_isen/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
